import { render } from "./MedicalNotes.vue?vue&type=template&id=f38e7d8c"
import script from "./MedicalNotes.vue?vue&type=script&lang=js"
export * from "./MedicalNotes.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__